module.exports = __webpack_public_path__ + "img/work4.c029fe01.png";